import { Pipe, PipeTransform } from '@angular/core';
import memo from 'memo-decorator';

@Pipe({
  name: 'propertyInObject',
  pure: true
})
export class PropertyInObjectPipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @memo()
  transform(obj: any, property: string): boolean {
    if (property in obj) {
      return true;
    }

    return false;
  }
}
